/* fx-mobile.js: the 24 Sep mobile pass. Pairs with fx-mobile.css.
   One job: take the injected search field out of the slide out menu. */
(function () {
  "use strict";

  /* The theme's own header search is switched off in the header section
     settings, so the field in the menu is coming from an installed search app
     that injects after the theme has run. The stylesheet hides it; this also
     takes it out of the DOM, so it leaves no gap behind, and it runs on a
     MutationObserver because an injected element can arrive at any moment,
     including after the menu is opened. Uninstalling the app is the real fix;
     this only covers the markup we can see. */
  var HIT = [
    'input[type="search"]',
    'input[name="q"]',
    'form[action*="/search"]',
    'form[action*="expertrec"]',
    '[class*="cse-"]',
    '[id*="cse-"]',
    '[class*="expertrec"]',
    '[id*="expertrec"]'
  ].join(",");

  var frame = 0;

  function strip() {
    frame = 0;
    var panel = document.querySelector(".fx-panel");
    if (!panel) return;
    var hits = panel.querySelectorAll(HIT);
    for (var i = 0; i < hits.length; i++) {
      var el = hits[i];
      /* The cart lives inside the same panel and its checkout form must stay. */
      if (el.closest(".fx-cart")) continue;
      var box = el.closest("form") || el;
      var wrap = box.parentElement;
      /* Take the wrapper when it exists only to hold this, so the menu does not
         keep the gap the field was sitting in. */
      if (wrap && wrap !== panel && wrap.children.length === 1) wrap.remove();
      else box.remove();
    }
  }

  function schedule() {
    if (frame) return;
    frame = setTimeout(strip, 40);
  }

  function start() {
    strip();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
